import React from "react"

import "./jobDetail.scss"

export default function JobDetail() {
  return (
    <div className="job-detail mb-72px mb-xl-0">
      <h6>Job Description</h6>
      <p>
        We are looking for highly motivated individuals for the position of
        Senior Software Engineer who is looking to grow their careers in a
        fast-paced environment. You will be developing information systems by
        studying operations; designing, developing, and installing software
        solutions; support and develop a software team. The Senior Software
        Engineer will lead a team of developers responsible for building new and
        support existing applications.
      </p>
      <h6>Qualifications</h6>
      <ul>
        <li>
          Bachelor's Degree/Master's degree in Computer Science is preferred
        </li>
        <li>Required minimum 5+ years of experience</li>
        <li>Experienced with sound knowledge in Python Programming Language</li>
        <li>Experience working in an agile environment</li>
        <li>Experience building complex web systems and applications</li>
        <li>Focused on performance and good knowledge of design patterns</li>
        <li>Experience implementing and consuming large scale web services</li>
      </ul>
      <h6>Responsibilities</h6>
      <ul>
        <li>
          Develop software solutions by studying information needs; conferring
          with users; studying systems flow, data usage, and work processes;
          investigating problem areas; following the software development
          life-cycle
        </li>
        <li>
          Determine operational feasibility by evaluating analysis, problem
          definition, requirements, solution development, and proposed solutions{" "}
        </li>

        <li>
          Must be able to work across multiple facets of the project and juggle
          multiple responsibilities at the same time
        </li>
        <li>Collaborate with team to brainstorm and create new products</li>
      </ul>
      <div className="text-end">
        <a href="#" className="btn btn-filled-v4">
          Apply
        </a>
      </div>
    </div>
  )
}
